import { type AnnouncementNarrowInput, type AnnouncementSurface } from '../constants';
import { narrowAnnouncementSettings } from './narrowAnnouncementSettings';
import { isLiveAt } from './timestamps';

export type SurfaceAnnouncement = AnnouncementNarrowInput & {
  expiresAt?: string | null;
  id: string;
  publishedAt?: string | null;
};

const placedOn = (announcement: AnnouncementNarrowInput, surface: AnnouncementSurface): boolean => {
  return Boolean(narrowAnnouncementSettings(announcement).placements[surface]);
};

/**
 * The announcement placed on this surface.
 * The server already returns at most one active announcement per surface.
 */
export const pickAnnouncementForSurface = <T extends SurfaceAnnouncement>({
  announcements,
  now,
  surface,
}: {
  announcements: readonly T[];
  now: Date;
  surface: AnnouncementSurface;
}): T | null => {
  return announcements.find((announcement) => isLiveAt(announcement, now) && placedOn(announcement, surface)) ?? null;
};
